import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  law: {
    flexWrap: 'nowrap',
    height: 56,
    display: 'flex',
    borderRadius: 8,
    width: '100%',
    alignItems: 'center',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    paddingLeft: 16,
    paddingRight: 16,
    transition: 'background-color 100ms linear',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default,
      '& .MuiChip-root': {
        backgroundColor: theme.palette.divider
      }
    }
  },
  title: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center'
  },
  articles: {
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center',
    width: 214
  },
  country: {
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center',
    width: 160
  },
  source: {
    flexGrow: 0,
    width: 120,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    width: 45
  },
  popover: {
    pointerEvents: 'none'
  },
  paperPopover: {
    maxWidth: '250px',
    wordBreak: 'break-all'
  },
  fullWidth: {
    width: '95%'
  }
}))

export default useStyles
